<template>
    <div class="header-page">
         <div class="header-left">
             <el-avatar shape="square" :size="size" :src="srcUrl"></el-avatar>
             <span style="margin-left:8px;">星程智能-交付管理系统</span>
         </div>
         <div class="header-right">
            欢迎，
            <el-dropdown>
               <div class="account-name">{{nickname}}</div>
               <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item>
                        <span @click="onPassword">修改密码</span>
                    </el-dropdown-item>
                    <el-dropdown-item>
                        <span @click="onLoginOut">退出</span>
                    </el-dropdown-item>
               </el-dropdown-menu>
            </el-dropdown>
            <PasswordForm :visible="visible" @onHidden="onHidden"/>
         </div>
    </div>
</template>
<script>
import srcUrl from '@/assets/logo.png'
import {clearCache,getCache} from '@/utils'
import PasswordForm from '../password-form'

export default {
    name:"headerPage",
    components:{
        PasswordForm
    },
    data(){
        return {
            visible:false,
            size:50,
            srcUrl,
            nickname:getCache('xczn_admin_nickname')
        }
    },
    methods:{
        onPassword(){
            this.visible = true
        },
        onHidden(){
            this.visible= false
        },
        onLoginOut(){
            this.$confirm('您确定是否要退出登录?', '系统提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                clearCache("xczn_admin_token")
                clearCache("xczn_admin_nickname")
                this.$router.push({path:"/login"})
            }).catch(() => {
                   
            });
        }
    }
}
</script>
<style scoped>
.header-page{
    height: 56px;
    border-bottom:1px solid #ebebeb;
    box-sizing: border-box;
    background-color: #ffffff;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
}
.header-left{
    display: flex;
    font-family: AlibabaPuHuiTi;
    font-size: 18px;
    font-weight: 500;
    line-height: normal;
    letter-spacing: 0em;
    align-items: center;
}
.header-right{
    display: flex;
    align-items: center;
    width: 220px;
    justify-content:flex-end;
    font-size: 14px;
}
.account-name{
    cursor: pointer;
    color:#66b1ff;
}
</style>



// WEBPACK FOOTER //
// src/components/header/index.vue